export const DARK_THEME_ENABLED = false;

export const getCurrentThemeMode = (): boolean => {
    if (!DARK_THEME_ENABLED) {
        return false;
    }

    try {
        const saved = localStorage.getItem('dark-mode');
        return saved === 'true';
    } catch (error) {
        console.error('Error reading dark mode from localStorage:', error);
        return false;
    }
};

export const setThemeMode = (isDark: boolean): void => {
    try {
        const enabledDarkMode = DARK_THEME_ENABLED && isDark;
        localStorage.setItem('dark-mode', enabledDarkMode.toString());
        if (enabledDarkMode) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    } catch (error) {
        console.error('Error saving dark mode to localStorage:', error);
    }
};

export const toggleThemeMode = (): boolean => {
    if (!DARK_THEME_ENABLED) {
        setThemeMode(false);
        return false;
    }

    const currentMode = getCurrentThemeMode();
    const newMode = !currentMode;
    setThemeMode(newMode);
    return newMode;
};
